import countries from 'data/countries';
import isArrayNotEmpty from 'utils/isArrayNotEmpty';

const activeCountry = countries[process.env.GATSBY_COUNTRY_CODE]?.contentfulName;

export default function (locations) {
  if (isArrayNotEmpty(locations))
    return locations
      .filter(({ country }) => country === activeCountry)
      .map(({ id, name, state, city, code }) => ({ id, name, state, value: code, city }));
}
